<template>
  <div>
    <el-dialog
      ref="addEditViewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="h360_dialog abow_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @open="handleOpen('addEditViewDialog')"
    >
      <div
        v-loading="loading"
        :loading="loading"
        :element-loading-text="$t('detailPage.loading')"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-form
          ref="dialogAddEditViewForm"
          :model="dialogAddEditViewForm"
          :rules="eventType==='view' ? null : dialogAddEditViewFormRules"
          class="add-edit-view-form"
          @submit.native.prevent
        >
          <div class="modal-box">
            <h3 class="modal-title">
              基础信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item
                    label="名称"
                    prop="name"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.name"
                      :disabled="eventType==='view'"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="生产厂家"
                    prop="manufacturer"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.manufacturer"
                      :disabled="eventType==='view'"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="modal-box">
            <h3 class="modal-title">
              备注信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-form-item prop="remark">
                    <el-input
                      v-model="dialogAddEditViewForm.remark"
                      type="textarea"
                      placeholder="备注"
                      style="margin-top:10px;"
                      :disabled="eventType==='view'"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          v-if="eventType!=='view'"
          type="primary"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// 数据请求
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
import { initBrandApi, saveOrUpdateBrandApi } from '@/api/brand'
export default {
  components: { },
  mixins: [dialogDragMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      loading: true,
      dialogAddEditViewForm: {},
      dialogAddEditViewFormRules: {
        name: [ { required: true, message: '请输入名称', trigger: 'blur' }],
        manufacturer: [ { required: true, message: '请输入生产厂家', trigger: 'blur' }],
        remark: [{ max: 128, message: '最多输入128个字符', trigger: 'blur' } ]
      }
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.dialogAddEditViewForm.clearValidate()
        })
        this.loading = true
        this.dialogAddEditViewForm = {
          name: '',
          manufacturer: '',
          remark: ''
        }
        if (this.eventType !== 'add') {
          this.initPageData()
        } else {
          this.loading = false
        }
      }
    }
  },
  methods: {
    // 加载数据
    initPageData () {
      initBrandApi({ id: this.dataId }).then(res => {
        const { data } = res
        for(let key in this.dialogAddEditViewForm) {
          this.dialogAddEditViewForm[key] = data[key]
        }
        this.dialogAddEditViewForm.id = data.id
        this.loading = false
      })
    },
    // 加载数据
    reloadData () {
      this.$emit('reloadData')
    },
    modalClose () {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
      this.$refs.dialogAddEditViewForm.clearValidate()
    },
    // 新增|修改保存
    handleSave () {
      this.$refs.dialogAddEditViewForm.validate(valid => {
        if (valid) {
          this.$confirm(
            (this.eventType === 'add' ? '是否确定新增' : '是否确定修改') + '物料品牌','系统提示',
            {
              confirmButtonText: '确定',
              cancelButtonText:'取消',
              type: 'warning',
              center: true
            }
          )
            .then(async () => {
              this.loading = true
              this.saveOrUpdate()
            })
            .catch(() => { })
        }
      })
    },
    // 保存新增
    saveOrUpdate () {
      saveOrUpdateBrandApi(this.dialogAddEditViewForm).then(res => {
        if (res.mark === '200') {
          this.$message({ message: res.message, type: 'success' })
          this.reloadData()
          this.modalClose()
        }
      }).catch(() => {
        this.loading = false
      })
    }
  }
}
</script>
<style lang="scss"  scoped>

</style>
